import React from 'react'
import { Provider } from 'react-redux'
import { ApolloProvider } from '@apollo/react-hooks'
import { initializeStore, client } from 'redux/redux'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'

import Navigation from 'components/layout/navigation'
import Footer from 'components/layout/footer'
import SignUp from 'pages/signUp'
import Login from 'pages/login'
import ForgotPassword from 'pages/forgotPassword'

import SettingsUserData from 'pages/settingsUserData'
import SettingsLogo from 'pages/settingsLogo'
import SettingsCompanyDetails from 'pages/settingsCompanyDetails'
import SettingsResetPassword from 'pages/settingsResetPassword'
import SettingsPriceOverview from 'pages/settingsPriceOverview'
import SettingsTimeOverview from 'pages/settingsTimeOverview'

import Manual from 'pages/manual'
import TermsOfUseRigips from 'pages/termsOfUseRigips'
import LinksRigips from 'pages/linksRigips'

import Tutorial from 'pages/tutorial'
import TermsOfUseAbk from 'pages/termsOfUseAbk'
import LinksAbk from 'pages/linksAbk'

import Feedback from 'pages/feedback'

import Calculations from 'pages/calculations'
import CalculationOverview from 'pages/calculationOverview'
import CalculationMaterialRequirement from 'pages/calculationMaterialRequirement'
import CalculationTimeRequirement from 'pages/calculationTimeRequirement'
import NewCalculation from 'pages/newCalculation'

import Projects from 'pages/projects'
import ProjectOverview from 'pages/projectOverview'
import ProjectMaterialRequirement from 'pages/projectMaterialRequirement'
import ProjectTimeRequirement from 'pages/projectTimeRequirement'
import ProjectSettings from 'pages/projectSettings'
import NewProject from 'pages/newProject'
import PrivateRoute from 'components/layout/privateRoute'

import Manufacturers from 'pages/manufacturers'

const rdx = initializeStore()
export const store = rdx.store

const App: React.FC = () => {
  return (
    <ApolloProvider client={client}>
      <Provider store={store}>
        <Router>
          <div className="App">
            <Route component={Navigation} />
            <Switch>
              <Route exact path="/" component={Login} />

              <Route exact path="/login" component={Login} />
              <Route exact path="/signup" component={SignUp} />
              <Route exact path="/forgot-password" component={ForgotPassword} />

              {process.env.REACT_APP_ENV === 'rigips' && (
                <Route exact path="/help" render={() => <Redirect to="/help/manual" />} />
              )}
              {process.env.REACT_APP_ENV === 'rigips' && (
                <Route path="/help/manual" component={Manual} />
              )}
              {process.env.REACT_APP_ENV === 'rigips' && (
                <Route path="/help/terms-of-use" component={TermsOfUseRigips} />
              )}
              {process.env.REACT_APP_ENV === 'rigips' && (
                <Route path="/help/links" component={LinksRigips} />
              )}

              {process.env.REACT_APP_ENV === 'abk' && (
                <Route exact path="/faq" render={() => <Redirect to="/faq/terms-of-use" />} />
              )}
              {process.env.REACT_APP_ENV === 'abk' && (
                <Route path="/faq/terms-of-use" component={TermsOfUseAbk} />
              )}
              {process.env.REACT_APP_ENV === 'abk' && (
                <Route path="/faq/tutorial" component={Tutorial} />
              )}
              {process.env.REACT_APP_ENV === 'abk' && (
                <Route path="/faq/links" component={LinksAbk} />
              )}

              <Route exact path="/feedback" component={Feedback} />

              <Route exact path="/settings" render={() => <Redirect to="/settings/user-data" />} />
              <PrivateRoute path="/settings/user-data" component={SettingsUserData} />
              <PrivateRoute path="/settings/logo" component={SettingsLogo} />
              <PrivateRoute path="/settings/company-details" component={SettingsCompanyDetails} />
              <PrivateRoute path="/settings/reset-password" component={SettingsResetPassword} />
              <PrivateRoute path="/settings/price-overview" component={SettingsPriceOverview} />
              <PrivateRoute path="/settings/time-overview" component={SettingsTimeOverview} />

              <PrivateRoute exact path="/calculations" component={Calculations} />
              <PrivateRoute path="/calculations/new-calculation" component={NewCalculation} />
              <PrivateRoute
                path="/calculations/:calculationId/material-requirement"
                component={CalculationMaterialRequirement}
              />
              <PrivateRoute
                path="/calculations/:calculationId/time-requirement"
                component={CalculationTimeRequirement}
              />
              <PrivateRoute path="/calculations/:calculationId" component={CalculationOverview} />

              <PrivateRoute exact path="/projects" component={Projects} />
              <PrivateRoute path="/projects/new-project" component={NewProject} />
              <PrivateRoute
                path="/projects/:projectId/new-calculation"
                component={NewCalculation}
              />
              <PrivateRoute
                path="/projects/:projectId/calculations/:calculationId/material-requirement"
                component={CalculationMaterialRequirement}
              />
              <PrivateRoute
                path="/projects/:projectId/calculations/:calculationId/time-requirement"
                component={CalculationTimeRequirement}
              />
              <PrivateRoute
                path="/projects/:projectId/calculations/:calculationId"
                component={CalculationOverview}
              />
              <PrivateRoute
                path="/projects/:projectId/material-requirement"
                component={ProjectMaterialRequirement}
              />
              <PrivateRoute
                path="/projects/:projectId/time-requirement"
                component={ProjectTimeRequirement}
              />
              <PrivateRoute path="/projects/:projectId/settings" component={ProjectSettings} />
              <PrivateRoute path="/projects/:projectId" component={ProjectOverview} />

              {process.env.REACT_APP_ENV === 'abk' && (
                <PrivateRoute exact path="/manufacturers" component={Manufacturers} />
              )}
            </Switch>
            <Route component={Footer} />
          </div>
        </Router>
      </Provider>
    </ApolloProvider>
  )
}

export default App
